import React, { Component } from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import 'components/common/CardsGrid/cards-grid.scss'
import PropTypes from 'prop-types'
import { List } from 'immutable'
import ectoDashboard from 'assets/img/apps/Dashboards.svg'
import { REFERRER_TYPES } from 'routes/App/Apps/MonitorsAndAlerts/logTypes'

class CardsGrid extends Component {
  repeatCard = () => {
    const { cards } = this.props
    const size = cards.size > 2 ? 4 : 6

    return cards.map(
      ({
        appUrl,
        appName,
        appTitle,
        appDescription,
        appIconPath,
        enableInUi,
      }) => {
        const icon = appIconPath || ectoDashboard

        return (
          <Grid
            item
            lg={size}
            md={size}
            sm={6}
            xs={12}
            key={`card_${appTitle}`}
            className="grid-item">
            <Paper
              className={cn('card-item', { 'item-disabled': !enableInUi })}
              elevation={5}>
              <NavLink
                key={appTitle}
                to={appUrl}
                onClick={() => {
                  localStorage.setItem('referrer', REFERRER_TYPES.APPS)
                }}>
                <img alt={appName} className="card-icon" src={icon} />
                <div className="text-wrap">
                  <Typography className="card-name">{appName}</Typography>
                  {appDescription && (
                    <Typography className="card-description">
                      {appDescription}
                    </Typography>
                  )}
                </div>
              </NavLink>
            </Paper>
          </Grid>
        )
      },
    )
  }

  render() {
    return (
      <div className="cards-content">
        <Grid container spacing={3} className="grid-container">
          {this.repeatCard()}
        </Grid>
      </div>
    )
  }
}

CardsGrid.propTypes = {
  cards: PropTypes.instanceOf(List),
}

export default CardsGrid
